import { render, staticRenderFns } from "./appBar.vue?vue&type=template&id=5b4e59d4"
import script from "./appBar.vue?vue&type=script&lang=js"
export * from "./appBar.vue?vue&type=script&lang=js"
import style0 from "./appBar.vue?vue&type=style&index=0&id=5b4e59d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports